/* Video editor (MeReveal). Opens from the studio's Video templates, or standalone in motion-lab.

   Parts mode (e.g. the 16-sheet paper wall): two real Dynamic Mockups renders of the same template, blank and with
   the member's photo. Each beat one more part shows the finished render, cut along its own edge using a parts map
   traced from the blank render (motion-lab/sheet-map.py). The last frame is the finished render.
   Stack mode (opts.stack, e.g. Paper creased scan 05): 2 to 10 photos in a tray, every beat is its own real render.
   With stack { min: 1, max: 1 } it takes one photo and plays the frames the page renders for it (the envelope series).

   MeReveal.open({
     blank: url, map: url (parts only), template: 'Name shown under the preview',
     stack: { min: 2, max: 10 } (stack mode; each: true centres every frame on its own papers),
     render: parts: function (file) -> Promise<url>; stack: function (files) -> Promise<[url per frame]>,
     photos: [File] (optional, start with these; autoBuild: true makes a stack straight away), message: shown by the button,
     onMade: function (blob, name) (optional), beforeExport / exportLabel / againLabel (paid downloads, see below),
     beforeUpload, costNote, mount (build into a page instead of an overlay), onClose
   })
   Needs me-reveal.css, and me-motion.js for the MP4 export. Image URLs must allow canvas reads.
   Crumple, Pop, Click, Flash and Stamp play real recorded hits from me-sounds.js (load it before this file);
   Page is still synthesised. Paper and Tear were taken out (26 Oct, Kaitlin: "they sound weird"). They go into the MP4 where the browser can
   encode audio; otherwise the video is silent and the panel says so. */
(function () {
  'use strict';

  var OUT = 30, SLOWEST = .8, FASTEST = .08;
  var ORDERS = [
    { id: 'rows', label: 'In order' },
    { id: 'shuffle', label: 'Shuffle' },
    { id: 'centre', label: 'Centre out' }
  ];
  var SOUNDS = [
    { id: 'none', label: 'None' },
    { id: 'page', label: 'Page' },
    { id: 'crumple', label: 'Crumple' },
    { id: 'click', label: 'Click' },
    { id: 'pop', label: 'Pop' },
    { id: 'flash', label: 'Flash' },
    { id: 'stamp', label: 'Stamp' }
  ];
  // Always end quick: the last part gets one beat, no extra hold (Kaitlin, 29 Oct).
  var HOLDS = [
    { id: '0', label: 'Quick', s: 0 }
  ];
  var PLAYS = [
    { id: '1', label: 'Once', n: 1 },
    { id: '2', label: 'Twice', n: 2 },
    { id: '3', label: '3 times', n: 3 }
  ];
  var MARK = 'MOCK EXCHANGE';
  /* the only two things the loader ever says (Kaitlin, 23 Sep) */
  var MAKING = 'Creating video', EXPORTING = 'Exporting';
  var SIZES = [
    { id: '9x16', W: 1080, H: 1920, label: '9:16' },
    { id: '4x5', W: 1080, H: 1350, label: '4:5' },
    { id: '1x1', W: 1080, H: 1080, label: '1:1' }
  ];
  var CURSOR = '<svg viewBox="0 0 17 21" shape-rendering="crispEdges" aria-hidden="true"><path fill="#fff" d="M5 1h2v7h1V6h2v2h1V7h2v2h1V8h2v8h-1v2h-1v2H6v-2H5v-2H4v-1H3v-1H2v-1H1v-3h3v1h1z"/><path fill="#141414" d="M5 0h2v1H5zM4 1h1v10H4zM7 1h1v5H7zM8 5h2v1H8zM10 6h1v1h-1zM11 6h2v1h-2zM13 7h1v1h-1zM14 7h2v1h-2zM16 8h1v8h-1zM15 16h1v2h-1zM14 18h1v2h-1zM6 20h8v1H6zM5 18h1v2H5zM4 16h1v2H4zM3 15h1v1H3zM2 14h1v1H2zM1 13h1v1H1zM0 10h1v3H0zM1 10h3v1H1zM7 6h1v4H7zM10 7h1v3h-1zM13 8h1v2h-1z"/></svg>';
  var PLAY = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9.5-5.5z" fill="currentColor"/></svg>';
  var PAUSE = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1.5" width="3.4" height="11" fill="currentColor"/><rect x="8.6" y="1.5" width="3.4" height="11" fill="currentColor"/></svg>';

  function find(list, id) { for (var i = 0; i < list.length; i++) { if (list[i].id === id) { return list[i]; } } return list[0]; }
  function R(a, b) { var x = Math.sin(a * 127.1 + b * 311.7 + 13.37) * 43758.5453; return x - Math.floor(x); }
  function beatFor(speed) { return SLOWEST * Math.pow(FASTEST / SLOWEST, speed / 100); }
  function speedFor(beat) { return Math.max(0, Math.min(100, Math.round(Math.log(beat / SLOWEST) / Math.log(FASTEST / SLOWEST) * 100))); }
  function fileLabel(name) {
    var m = String(name || 'photo').match(/^(.*?)(\.[a-z0-9]+)?$/i);
    return (m[1] || 'photo').toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_|_$/g, '') + (m[2] || '.JPG').toUpperCase();
  }
  /* Dynamic Mockups' renders come from an S3 bucket in Frankfurt. Measured from Australia on 30 Sep that link runs
     at about 0.06 MB/s and drops connections outright (ECONNRESET), and a full-size frame is half a megabyte. With
     no timeout an <img> that stalls just never resolves, so the export sat at its 33% cap for ever and looked like
     a hang (Kaitlin: "theres a bug where exports STOP at 33%"). One retry on a fresh connection, then give up
     with words that say what happened. */
  var IMG_WAIT = 25000;
  function loadImg(url, attempt) {
    return new Promise(function (res, rej) {
      var im = new Image(), done = false, timer = 0;
      function finish(ok) { if (done) { return; } done = true; clearTimeout(timer); im.onload = im.onerror = null; ok ? res(im) : rej(new Error('stalled')); }
      im.crossOrigin = 'anonymous';
      im.onload = function () { finish(true); };
      im.onerror = function () { finish(false); };
      timer = setTimeout(function () { im.src = ''; finish(false); }, IMG_WAIT);
      /* a retry must not be served the dead connection's cache entry. Not on a blob:/data: link (the doily's
         frames are made in the page), where a query just makes it a link to nothing. Callers wrap loadImg
         rather than pass it to map(): map hands over the index as `attempt`, so every frame after the first
         loaded as if it were already a retry (1 Nov). */
      im.src = attempt && !/^(blob|data):/.test(url) ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'r=' + attempt : url;
    }).catch(function (e) {
      if ((attempt || 0) >= 1) { throw new Error('Those frames wouldn’t download. Check your connection and press Download again.'); }
      return loadImg(url, (attempt || 0) + 1);
    });
  }

  /* ------------------------------------------------------------ sound */
  var noiseCache = null;
  function noise(ac) {
    if (noiseCache && noiseCache.sampleRate === ac.sampleRate) { return noiseCache; }
    var b = ac.createBuffer(1, Math.round(ac.sampleRate * .5), ac.sampleRate), d = b.getChannelData(0);
    for (var i = 0; i < d.length; i++) { d[i] = Math.random() * 2 - 1; }
    return (noiseCache = b);
  }
  function burst(ac, out, when, dur, type, freq, q, gain, offset) {
    var src = ac.createBufferSource(), f = ac.createBiquadFilter(), g = ac.createGain();
    src.buffer = noise(ac); f.type = type; f.frequency.value = freq; f.Q.value = q;
    g.gain.setValueAtTime(0.0001, when);
    g.gain.exponentialRampToValueAtTime(gain, when + .004);
    g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
    src.connect(f); f.connect(g); g.connect(out);
    src.start(when, offset % .4, dur + .02);
  }
  function tone(ac, out, when, from, to, dur, gain, type) {
    var o = ac.createOscillator(), g = ac.createGain();
    o.type = type || 'sine';
    o.frequency.setValueAtTime(from, when); o.frequency.exponentialRampToValueAtTime(to, when + dur);
    g.gain.setValueAtTime(0.0001, when);
    g.gain.exponentialRampToValueAtTime(gain, when + .005);
    g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
    o.connect(g); g.connect(out); o.start(when); o.stop(when + dur + .02);
  }
  /* Real sounds (26 Oct, Kaitlin: "using the new sounds in my dropbox redo the sound effects"): single hits cut from
     her Epidemic Sound downloads, in me-sounds.js (motion-lab/sounds/build-sounds.py). Each clip becomes an
     AudioBuffer once; a buffer plays in any context, the offline export one included. A kind with no clips (page) or a page without me-sounds.js gets the synthesised sound further down. */
  var clipCache = {}, lastCrumple = -1;
  function clipBuf(ac, name) {
    var S = window.MeSounds;
    if (!S || !S.clips[name]) { return null; }
    if (clipCache[name]) { return clipCache[name]; }
    var bin = atob(S.clips[name]), len = bin.length >> 1, buf, k, s;
    try { buf = new AudioBuffer({ length: len, numberOfChannels: 1, sampleRate: S.rate }); } catch (e) { buf = ac.createBuffer(1, len, S.rate); }
    var d = buf.getChannelData(0);
    for (k = 0; k < len; k++) { s = bin.charCodeAt(2 * k) | (bin.charCodeAt(2 * k + 1) << 8); d[k] = (s > 32767 ? s - 65536 : s) / 32768; }
    return (clipCache[name] = buf);
  }
  /* how many clips are named <prefix>1, <prefix>2…, so adding more in build-sounds.py needs no change here */
  function clipCount(prefix) {
    var S = window.MeSounds, k = 0;
    while (S && S.clips[prefix + (k + 1)]) { k++; }
    return Math.max(1, k);
  }
  /* room cuts the clip short with a quick fade, so a fast beat never smears into the next hit */
  function sample(ac, out, when, name, gain, rate, room) {
    var buf = clipBuf(ac, name);
    if (!buf) { return false; }
    var src = ac.createBufferSource(), g = ac.createGain(), len = buf.duration / rate;
    var end = room ? Math.min(len, Math.max(.05, room * .9)) : len;
    src.buffer = buf; src.playbackRate.value = rate;
    g.gain.setValueAtTime(gain, when);
    if (end < len) { g.gain.setValueAtTime(gain, when + end - .03); g.gain.linearRampToValueAtTime(0, when + end); }
    src.connect(g); g.connect(out); src.start(when); src.stop(when + end + .01);
    return true;
  }
  function real(kind, ac, out, when, i, n, room, last, p, v) {
    /* Every hit plays at its own pitch, the same on every beat (1 Nov, Kaitlin: "when you speed it up to the fastest
       option it makes sounds go higher in octave each beat, it shouldn't do that"). Pop used to climb half an octave
       over the run and every clip was nudged up or down a little per beat; at the fastest speed that read as a scale.
       Variety comes from picking different crumple clips and from loudness, never from pitch. */
    var rate = 1;
    if (kind === 'crumple') {
      /* a different crumple every beat, never the same one twice running, each a touch louder or
         softer, so a run sounds like paper being handled rather than one clip on repeat (26 Oct, Kaitlin: "crumple
         shouldnt be so repetitive"). Not higher or lower any more: see rate above (1 Nov). */
      /* seeded on the time, not the photo, so the second and third time round the loop pick differently too */
      var seed = Math.round(when * 1000), cn = clipCount('crumple'), ck = Math.floor(R(seed, 3) * cn);
      if (ck === lastCrumple) { ck = (ck + 1) % cn; }
      lastCrumple = ck;
      return sample(ac, out, when, 'crumple' + (1 + ck), (last ? .8 : .55) * (.85 + R(seed, 5) * .3), rate, room);
    }
    if (kind === 'pop') { return sample(ac, out, when, 'pop' + (1 + i % 6), last ? .55 : .4, rate, room); }
    if (kind === 'click') { return sample(ac, out, when, 'click', 1, rate, room); }
    if (kind === 'flash') {
      /* a fast beat has no room for the whole shutter, which got cut off mid-sound (26 Oct, Kaitlin: "flash doesnt work
         when its fast"), so it gets just the clack; the full shutter where it fits, the flash on a long last beat */
      var fl = room && room < .4 ? 'flash-snap' : last && (!room || room > .5) ? 'flash-last' : 'flash';
      return sample(ac, out, when, fl, .7, rate, room);
    }
    if (kind === 'stamp') {
      /* a hard knock for the hit, with the low thump under it. The thump alone was the old stamp, and laptop and
         phone speakers barely play that low, so it sounded like nothing (26 Oct, Kaitlin: "stamp also doesnt work") */
      if (!sample(ac, out, when, 'stamp', last ? .9 : .75, rate, room)) { return false; }
      tone(ac, out, when, 190, 55, room ? Math.min(.13, room * .8) : .13, last ? .5 : .35);
      return true;
    }
    return false;
  }
  /* i = which sheet (0-based) of n. Each sound shifts a little per sheet so 16 in a row don't drone.
     room = seconds until the next sound: on a fast beat each sound is cut to fit, so beats don't smear into each
     other (21 Sep, Kaitlin: "at the end the sounds merge weirdly like d-d-d-d-DD-d-d-dd-DD"). */
  function play(kind, ac, out, when, i, n, room) {
    var last = i === n - 1, p = n > 1 ? i / (n - 1) : 1, v = R(i, 7), fit = room ? Math.max(.45, Math.min(1, room * .85 / .11)) : 1;
    if (real(kind, ac, out, when, i, n, room, last, p, v)) { return; }
    if (kind === 'click') {
      burst(ac, out, when, .018, 'highpass', 3000, .6, .7, v);
      burst(ac, out, when + .045, .03, 'bandpass', 2200, 1.2, .45, v * 2);
      tone(ac, out, when, 1900 + v * 300, 1500, .025, .12, 'square');
    } else if (kind === 'pop') {
      /* `fit` was missing here, so on a fast beat with a lot of frames each pop ran into the next and the run
         turned to mush (30 Sep, Kaitlin: "the bubble one sorta breaks when you have a few pics on it").
         Paper has had this since 21 Sep; pop never did. */
      var f0 = 440; /* one pitch every beat (1 Nov); it used to climb with the run */
      tone(ac, out, when, f0 * 1.9, f0, .09 * fit, last ? .7 : .5);
      if (last) { tone(ac, out, when + .09 * fit, f0 * 2.6, f0 * 2, .14 * fit, .35); }
    } else if (kind === 'flash') {
      /* camera flash: the shutter snap, then the capacitor whining back up to charge */
      burst(ac, out, when, .014 * fit, 'highpass', 5200, .7, last ? .9 : .75, v);
      burst(ac, out, when + .02 * fit, .05 * fit, 'bandpass', 2600, 1.4, .3, v * 2);
      tone(ac, out, when + .03 * fit, 2400, 7200, .13 * fit, last ? .16 : .1, 'triangle');
    } else if (kind === 'page') {
      /* one page going over: a long soft swish that brightens as it lifts */
      burst(ac, out, when, .2 * fit, 'bandpass', 700 + v * 300, .8, last ? .5 : .38, v);
      burst(ac, out, when + .07 * fit, .16 * fit, 'bandpass', 2100 + v * 900, 1.1, .26, v * 2);

    } else if (kind === 'crumple') {
      /* scrunching: dense little cracks, with a soft body under it */
      for (var ci = 0; ci < 5; ci++) {
        burst(ac, out, when + ci * .016 * fit, .026 * fit, 'bandpass', 900 + R(i, ci) * 2200, 1.6, (last ? .45 : .34) * (1 - ci * .1), v + ci * 2);
      }
      tone(ac, out, when, 150, 70, .1 * fit, last ? .35 : .22);
    } else if (kind === 'stamp') {
      /* a rubber stamp: the thud carries it, with a little grit on top */
      tone(ac, out, when, 190, 55, .13 * fit, last ? .8 : .6);
      burst(ac, out, when, .03 * fit, 'lowpass', 1200, .7, .5, v);
      burst(ac, out, when + .01 * fit, .02 * fit, 'highpass', 3500, .6, .2, v * 3);
    }
  }

  /* ------------------------------------------------------------ sheet map */
  /* 21 Sep: on iPhone the wall turned into a speckled "fade". Safari now adds a little random noise to anything a page
     reads back from a canvas (anti-fingerprinting), and the map's parts are numbered 1, 2, 3... so a nudge of one
     moves a pixel into the next sheet. The map is now read straight from the PNG's own bytes (mapFrom, decodePng),
     which nothing can touch; the canvas read below is only the fallback for browsers without DecompressionStream. */
  function readMap(img) {
    var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
    var g = c.getContext('2d'); g.drawImage(img, 0, 0);
    var d = g.getImageData(0, 0, c.width, c.height).data, labels = new Uint8Array(c.width * c.height);
    for (var i = 0; i < labels.length; i++) { labels[i] = d[i * 4]; }
    return fromLabels(labels, c.width, c.height);
  }
  /* An 8-bit, non-interlaced PNG to one number per pixel (its first channel), with no canvas involved. */
  function decodePng(buf) {
    var dv = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    if (buf.length < 33 || dv.getUint32(0) !== 0x89504e47 || !window.DecompressionStream) { return Promise.resolve(null); }
    var i = 8, w = 0, h = 0, bd = 0, ct = 0, lace = 0, parts = [];
    while (i + 8 <= buf.length) {
      var len = dv.getUint32(i), type = String.fromCharCode(buf[i + 4], buf[i + 5], buf[i + 6], buf[i + 7]);
      if (type === 'IHDR') { w = dv.getUint32(i + 8); h = dv.getUint32(i + 12); bd = buf[i + 16]; ct = buf[i + 17]; lace = buf[i + 20]; }
      else if (type === 'IDAT') { parts.push(buf.subarray(i + 8, i + 8 + len)); }
      else if (type === 'IEND') { break; }
      i += 12 + len;
    }
    var bpp = { 0: 1, 2: 3, 4: 2, 6: 4 }[ct];
    if (bd !== 8 || lace || !bpp || !w || !h) { return Promise.resolve(null); }
    var stream = new Blob(parts).stream().pipeThrough(new DecompressionStream('deflate'));
    return new Response(stream).arrayBuffer().then(function (ab) {
      var raw = new Uint8Array(ab), stride = w * bpp, labels = new Uint8Array(w * h);
      var prev = new Uint8Array(stride), line = new Uint8Array(stride), p = 0, x, y;
      if (raw.length < h * (stride + 1)) { return null; }
      for (y = 0; y < h; y++) {
        var f = raw[p++];
        for (x = 0; x < stride; x++) {
          var v = raw[p++], a = x >= bpp ? line[x - bpp] : 0, up = prev[x], c = x >= bpp ? prev[x - bpp] : 0;
          if (f === 1) { v += a; } else if (f === 2) { v += up; } else if (f === 3) { v += (a + up) >> 1; }
          else if (f === 4) { var pa = Math.abs(up - c), pb = Math.abs(a - c), pc = Math.abs(a + up - 2 * c); v += (pa <= pb && pa <= pc) ? a : (pb <= pc ? up : c); }
          line[x] = v & 255;
        }
        for (x = 0; x < w; x++) { labels[y * w + x] = line[x * bpp]; }
        var t = prev; prev = line; line = t;
      }
      return { w: w, h: h, labels: labels };
    });
  }
  function mapFrom(url) {
    return fetch(url).then(function (r) { return r.arrayBuffer(); })
      .then(function (ab) { return decodePng(new Uint8Array(ab)); })
      .then(function (m) { return m ? fromLabels(m.labels, m.w, m.h) : null; })
      .catch(function () { return null; })
      .then(function (m) { return m || loadImg(url).then(readMap); });
  }
  function fromLabels(labels, w, h) {
    var sums = {}, n = 0, minX = w, minY = h, maxX = 0, maxY = 0;
    for (var i = 0; i < w * h; i++) {
      var v = labels[i];
      if (!v) { continue; }
      if (v > n) { n = v; }
      var x = i % w, y = (i / w) | 0;
      var s = sums[v] || (sums[v] = { x: 0, y: 0, c: 0 });
      s.x += x; s.y += y; s.c++;
      if (x < minX) { minX = x; } if (x > maxX) { maxX = x; } if (y < minY) { minY = y; } if (y > maxY) { maxY = y; }
    }
    var centres = [];
    for (var k = 1; k <= n; k++) { var t = sums[k] || { x: 0, y: 0, c: 1 }; centres[k] = { x: t.x / t.c / w, y: t.y / t.c / h }; }
    return { w: w, h: h, labels: labels, n: n, centres: centres, box: { cx: (minX + maxX) / 2 / w, cy: (minY + maxY) / 2 / h } };
  }

  /* ------------------------------------------------------------ engine */
  function Reveal(state, stack, zoom, each) {
    var map = null, blank = null, work = null, workKey = '', masks = {};
    /* parts mode: one full render per photo. Pass p pastes photo p over photo p-1 (over the blank on the first),
       so several photos re-paste the same wall and the last flows back into the first with no seam
       (Kaitlin, 20 Sep: "if they add like 5 and then it goes to the next one"). */
    var fulls = [];
    /* opts.watermark: previews carry our name until the video is bought, so a screen recording is no substitute
       for the download (Kaitlin, 20 Sep: "what if someone screenrecords instead of purchases?"). Cleared by
       setMarked(false) the moment the unlock succeeds, before any full-size frame or MP4 is made. */
    var marked = false, markImg = null;
    /* stack mode: each beat is its own real render (frames[k] = frame k+1), nothing is cut or masked */
    var frames = [], ground = '#808080', pile = null, piles = [];

    function set(parts) {
      if (parts.blank) { blank = parts.blank; ground = corner(blank); if (stack) { pile = findPile(blank); } }
      if (parts.frames) {
        if (stack) {
          frames = parts.frames;
          if (frames[0]) { ground = corner(frames[0]); pile = pileOf(frames) || pile; }
          piles = each ? frames.map(function (img) { return img && findPile(img); }) : [];
        }
        else { setFulls(parts.frames); }
      }
      if (parts.map) { map = parts.map; masks = {}; }
      if ('full' in parts) { setFulls(parts.full ? [parts.full] : []); }
    }
    /* the scanner bed colour, from the top-left corner, so a frame can sit in any size without a hard edge */
    function corner(img) {
      try {
        var c = document.createElement('canvas'); c.width = c.height = 1;
        var g = c.getContext('2d'); g.drawImage(img, 0, 0, 8, 8, 0, 0, 1, 1);
        var d = g.getImageData(0, 0, 1, 1).data; return 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
      } catch (e) { return ground; }
    }
    /* where the papers sit in the scan (0..1), found as everything that isn't the flat bed colour.
       The scans aren't centred, so the pile gets centred in the frame instead of the whole photo. */
    function findPile(img) {
      try {
        var w = 120, h = Math.round(120 * img.naturalHeight / img.naturalWidth);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var g = c.getContext('2d'); g.drawImage(img, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data, b = g.getImageData(1, 1, 1, 1).data;
        var x0 = w, y0 = h, x1 = 0, y1 = 0;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (Math.abs(d[i] - b[0]) + Math.abs(d[i + 1] - b[1]) + Math.abs(d[i + 2] - b[2]) > 36) {
              if (x < x0) { x0 = x; } if (x > x1) { x1 = x; } if (y < y0) { y0 = y; } if (y > y1) { y1 = y; }
            }
          }
        }
        if (x1 <= x0 || y1 <= y0) { return null; }
        return { cx: (x0 + x1 + 1) / 2 / w, cy: (y0 + y1 + 1) / 2 / h, x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
      } catch (e) { return null; }
    }
    /* one centre for the whole video: the box round the papers in EVERY frame. The Paper pile (24 Oct, Kaitlin: "i
       feel it isnt centered") uses a different scan a beat, each with its pile in a slightly different spot, so
       centring on the first frame's single sheet left the full pile off to one side. One box, so nothing jitters. */
    function pileOf(list) {
      var b = null;
      list.forEach(function (img) {
        var p = img && findPile(img);
        if (!p) { return; }
        b = b ? { x0: Math.min(b.x0, p.x0), y0: Math.min(b.y0, p.y0), x1: Math.max(b.x1, p.x1), y1: Math.max(b.y1, p.y1) } : p;
      });
      return b && { cx: (b.x0 + b.x1) / 2, cy: (b.y0 + b.y1) / 2 };
    }
    function setFulls(list) {
      fulls = list || [];
      if (fulls[0]) { work = document.createElement('canvas'); work.width = fulls[0].naturalWidth; work.height = fulls[0].naturalHeight; }
      workKey = '';
    }
    function photos() { return Math.max(1, fulls.length); }
    /* every part of every photo: 16 sheets across 3 photos is 48 beats */
    function count() { return stack ? frames.length : (map ? map.n * photos() : 0); }
    function rows() { var ids = []; for (var k = 1; k <= map.n; k++) { ids.push(k); } return ids; }
    function order() {
      var ids = rows();
      if (state.order === 'shuffle') {
        for (var i = ids.length - 1; i > 0; i--) { var j = Math.floor(R(state.seed, i) * (i + 1)); var t = ids[i]; ids[i] = ids[j]; ids[j] = t; }
      } else if (state.order === 'centre') {
        var cx = map.box.cx, cy = map.box.cy;
        ids.sort(function (a, b) {
          var A = map.centres[a], B = map.centres[b];
          return Math.hypot(A.x - cx, (A.y - cy) * 1.4) - Math.hypot(B.x - cx, (B.y - cy) * 1.4);
        });
      }
      return ids;
    }
    function orderKey() { return state.order + state.seed; }
    function mask(step) {
      var key = orderKey() + ':' + step;
      if (masks[key]) { return masks[key]; }
      var ids = order(), on = new Uint8Array(256);
      for (var i = 0; i < step; i++) { on[ids[i]] = 1; }
      var c = document.createElement('canvas'); c.width = map.w; c.height = map.h;
      var g = c.getContext('2d'), img = g.createImageData(map.w, map.h), d = img.data;
      for (var p = 0; p < map.labels.length; p++) { if (on[map.labels[p]]) { d[p * 4 + 3] = 255; } }
      g.putImageData(img, 0, 0);
      return (masks[key] = c);
    }
    function compose(step, img) {
      var key = orderKey() + ':' + step + ':' + img.src;
      if (key === workKey) { return; }
      var g = work.getContext('2d');
      g.globalCompositeOperation = 'source-over';
      g.clearRect(0, 0, work.width, work.height);
      if (step > 0) {
        g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
        g.drawImage(mask(step), 0, 0, work.width, work.height);
        g.globalCompositeOperation = 'source-in';
        g.drawImage(img, 0, 0);
        g.globalCompositeOperation = 'source-over';
      }
      workKey = key;
    }
    /* one pass = one beat per part, starting with the first part down on frame 0, then the hold on the
       finished photo. Repeats run the pass again. */
    function timing() {
      // rounded to whole video frames, so every beat is exactly the same length (0.35s would be 10 or 11 frames)
      var beat = Math.max(2, Math.round(beatFor(state.speed) * OUT)) / OUT, n = count();
      var plays = find(PLAYS, state.plays).n, hold = find(HOLDS, state.hold).s;
      var intro = 0; // the first part goes down on the very first frame, every pass
      // the hold starts the moment the last part appears. Quick (0) gives the last part one beat, like every other
      // part: it used to end on that frame, so on a loop the next play's first sound landed 1/30s after the last one
      // and the two hit as one loud double (21 Sep, "d-d-d-d-DD").
      var pass = intro + (n - 1) * beat + Math.max(hold, beat);
      // a stack loops: every photo gets a full beat, the last included, so the loop has no seam
      if (stack) { pass = n * beat + hold; }
      /* several photos on a parts template: each photo gets every part, one after another. One photo keeps the old
         timing exactly. */
      /* 21 Sep, Kaitlin: the next photo should start the moment the last square of the one before lands. So no pause
         between photos (each part still gets its full beat); the Ending hold comes once, on the last photo. */
      var per = map ? map.n : 0, ph = stack ? 1 : photos(), passDur = per * beat;
      if (!stack && ph > 1) { pass = ph * passDur + hold; }
      return { F: OUT, n: n, beat: beat, intro: intro, hold: hold, plays: plays, pass: pass, per: per, photos: ph, passDur: passDur,
        total: n ? Math.ceil(pass * plays * OUT) : 1 };
    }
    function stepAt(f, T) {
      var t = (f / OUT) % T.pass;
      if (t < T.intro) { return 0; }
      if (!stack && T.photos > 1) {
        var p = Math.min(T.photos - 1, Math.floor(t / T.passDur));
        return p * T.per + Math.min(T.per, Math.floor((t - p * T.passDur) / T.beat) + 1);
      }
      return Math.min(T.n, Math.floor((t - T.intro) / T.beat) + 1);
    }
    /* the part of the render that fills a W x H frame, centred on the sheets */
    function crop(W, H) {
      var base = fulls[0] || blank, bw = base.naturalWidth, bh = base.naturalHeight, k = Math.max(W / bw, H / bh);
      var sw = W / k, sh = H / k;
      var cx = map ? map.box.cx : .5, cy = map ? map.box.cy : .5;
      return { bw: bw, bh: bh, sw: sw, sh: sh, sx: Math.max(0, Math.min(bw - sw, cx * bw - sw / 2)), sy: Math.max(0, Math.min(bh - sh, cy * bh - sh / 2)) };
    }
    /* stack mode: the whole render, fitted inside the frame, on its own scanner bed colour */
    function drawFit(ctx, W, H, img) {
      // up to 30% wider than fitting, trimming bed at the sides, so the papers fill a tall frame
      // zoom (stack.zoom) closes in on a small subject, e.g. the envelope in the middle of its scan
      var k = Math.min(W * 1.3 / img.naturalWidth, H / img.naturalHeight) * (zoom || 1), w = img.naturalWidth * k, h = img.naturalHeight * k;
      ctx.fillStyle = ground; ctx.fillRect(0, 0, W, H);
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      /* stack.each (the Paper pile): every frame is a different scan, so each is centred on its own papers */
      var own = each ? piles[frames.indexOf(img)] : null, p = own || pile;
      var cx = p ? p.cx : .5, cy = p ? p.cy : .5;
      ctx.drawImage(img, W / 2 - cx * w, H / 2 - cy * h, w, h);
    }
    /* Tiled across the frame at an angle, in output coordinates, so it can't be cropped out and it reads on a
       light or a dark photo (dark behind, white on top). Quiet enough to judge the video by. */
    /* The same strip the PNG carries, drawn live, for the case where that file fails to load: a preview must never
       go out unmarked. Geometry is worked out as if the 9:16 PNG had been covered over this frame, so the two match
       in every shape. Was a diagonal tiling of MOCK EXCHANGE across the whole frame (25 Sep, Kaitlin: "this look
       TERRRIBLEEE") — it sat on the design they are deciding about. */
    function stamp(ctx, W, H) {
      var k = Math.max(W / 1080, H / 1920);
      var top = (H - 1920 * k) / 2 + (1920 * 0.62 - 96 / 2) * k, bh = 96 * k;
      ctx.save();
      ctx.fillStyle = 'rgba(14,14,14,.47)';
      ctx.fillRect(0, top, W, bh);
      ctx.fillStyle = 'rgba(255,255,255,.59)';
      ctx.fillRect(0, top, W, Math.max(1, 2 * k));
      ctx.fillRect(0, top + bh - Math.max(1, 2 * k), W, Math.max(1, 2 * k));
      var fam = 'ui-sans-serif, -apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif';
      ctx.textBaseline = 'middle';
      ctx.font = 300 + ' ' + Math.round(30 * k) + 'px ' + fam;
      try { ctx.letterSpacing = Math.round(30 * k * 0.45) + 'px'; } catch (e) { /* older browsers */ }
      ctx.textAlign = 'center';
      ctx.fillStyle = 'rgba(255,255,255,.92)';
      ctx.fillText(MARK, W / 2, top + bh / 2);
      ctx.font = 300 + ' ' + Math.round(19 * k) + 'px ' + fam;
      try { ctx.letterSpacing = Math.round(19 * k * 0.5) + 'px'; } catch (e) { /* older browsers */ }
      ctx.textAlign = 'right';
      ctx.fillStyle = 'rgba(255,255,255,.75)';
      ctx.fillText('PREVIEW', W - 36 * k, top + bh / 2);
      ctx.restore();
    }
    function draw(ctx, W, H, f, forced) {
      var theirs = paint(ctx, W, H, f, forced);
      /* only the frames with their photo on them: a blank template has nothing to protect, and the mark across an
         empty one reads as broken (Kaitlin, 20 Sep: "errr looks weird") */
      if (!marked || !theirs) { return; }
      /* the soft 9:16 PNG, covered over the frame so 4:5 and 1:1 crop it (Kaitlin: "a 9x16 soft layer PNG").
         stamp() stays as the fallback: if that file ever fails to load, a preview still can't go out unmarked. */
      if (markImg) {
        var k = Math.max(W / markImg.naturalWidth, H / markImg.naturalHeight);
        var mw = markImg.naturalWidth * k, mh = markImg.naturalHeight * k;
        ctx.drawImage(markImg, (W - mw) / 2, (H - mh) / 2, mw, mh);
      } else {
        stamp(ctx, W, H);
      }
    }
    /* returns whether the frame it just drew has their photo on it, which is what decides the watermark */
    function paint(ctx, W, H, f, forced) {
      if (stack) {
        var st = forced != null ? forced : (frames.length ? stepAt(f, timing()) : 0);
        var img = st > 0 ? frames[Math.min(st, frames.length) - 1] : blank;
        if (img) { drawFit(ctx, W, H, img); } else { ctx.fillStyle = '#eeeeee'; ctx.fillRect(0, 0, W, H); }
        return st > 0 && frames.length > 0;
      }
      if (!blank) { ctx.fillStyle = '#eeeeee'; ctx.fillRect(0, 0, W, H); return false; }
      var c = crop(W, H);
      var step = (!fulls.length || !map) ? 0 : (forced != null ? forced : stepAt(f, timing()));
      /* which photo is being pasted, and how much of it is up. Everything under it is the photo before,
         or the blank wall on the first pass. */
      var per = map ? map.n : 0;
      var pass = step > 0 ? Math.floor((step - 1) / per) : 0;
      var within = step > 0 ? ((step - 1) % per) + 1 : 0;
      var under = pass > 0 ? fulls[pass - 1] : blank;
      var rx = under.naturalWidth / c.bw, ry = under.naturalHeight / c.bh;
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(under, c.sx * rx, c.sy * ry, c.sw * rx, c.sh * ry, 0, 0, W, H);
      if (!step) { return false; }
      compose(within, fulls[Math.min(pass, fulls.length - 1)]);
      ctx.drawImage(work, c.sx, c.sy, c.sw, c.sh, 0, 0, W, H);
      return true;
    }
    /* screen position (0..1 of the frame) of a sheet's centre, and which sheet is under a point */
    function where(k, W, H) {
      if (stack || !map) { return { x: .38 + R(k, 3) * .24, y: .36 + R(k, 4) * .28 }; }
      var c = crop(W, H), p = map.centres[k]; return { x: (p.x * c.bw - c.sx) / c.sw, y: (p.y * c.bh - c.sy) / c.sh }; }
    /* When each part lands, the same way stepAt draws it. Several photos on a parts template used to pause on each
       finished photo before the next one pasted over it; the sounds ignored that pause, ran ahead of the picture and
       piled up at the end of every play. Each photo also gets its own run of sounds, finishing on the
       accent as its last part lands. */
    function beats() {
      var T = timing(), out = [];
      if (!count()) { return out; }
      var multi = !stack && T.photos > 1;
      for (var p = 0; p < T.plays; p++) {
        for (var i = 0; i < T.n; i++) {
          var j = multi ? i % T.per : i, k = multi ? Math.floor(i / T.per) : 0;
          out.push({ at: p * T.pass + (multi ? k * T.passDur + j * T.beat : T.intro + i * T.beat), i: j, n: multi ? T.per : T.n, room: T.beat });
        }
      }
      return out;
    }
    function sounds(ac, out) {
      if (state.sound === 'none') { return; }
      beats().forEach(function (b) { play(state.sound, ac, out, b.at, b.i, b.n, b.room); });
    }
    return {
      set: set, timing: timing, draw: draw, stepAt: stepAt, where: where, sounds: sounds, beats: beats, order: order,
      setMarked: function (on) { marked = !!on; },
      setMark: function (img) { markImg = img; },
      sheets: count, hasFull: function () { return stack ? frames.length > 0 : fulls.length > 0; }
    };
  }

  /* ------------------------------------------------------------ studio */
  var current = null;

  function open(opts) {
    if (current) { current.close(); }
    opts = opts || {};
    var state = { hold: '0', plays: '1', order: 'rows', speed: speedFor(.16), sound: 'click', size: '9x16', seed: 1, view: null };
    /* opts.stack = { max: 5 }: several photos, one real render per beat (e.g. papers landing on a pile) */
    var stack = opts.stack || null, maxPhotos = stack ? (stack.max || 10) : 1, minPhotos = stack ? (stack.min || 2) : 1;
    /* opts.size: the shape to open on, for a template that 9:16 would cut in half (the mega screen) */
    if (opts.size) { state.size = find(SIZES, opts.size).id; }
    /* a parts template (it has a map) draws by cutting its render along the map, even when opts.stack gives it
       a tray of photos: the tray is the UI, the map is the drawing. */
    var partsMode = !!opts.map;
    var reveal = Reveal(state, !!stack && !partsMode, stack && stack.zoom, !!(stack && stack.each));
    /* opts.watermark: the Video tab passes this, and clears it on the unlock (handle.setPaid) */
    if (opts.watermark) {
      reveal.setMarked(true);
      if (opts.markSrc) {
        loadImg(opts.markSrc).then(function (img) { reveal.setMark(img); dirty = true; }).catch(function () { /* the drawn one covers it */ });
      }
    }
    /* the note sits under the frame, so the frame has to give up the room or it lands on the transport */
    function markNote(on) {
      /* Off for good (25 Sep). The watermark itself stays on previews; only the line under the frame is gone. */
      on = false;
      var el = q('[data-marknote]');
      if (!el) { return; }
      el.textContent = opts.markNote || 'pay to remove watermark';
      var heart = document.createElement('i');
      heart.className = 'mx-sheet__heart'; heart.textContent = '\u2665'; heart.setAttribute('aria-hidden', 'true');
      el.appendChild(heart);
      el.hidden = !on;
      root.classList.toggle('has-mark', !!on);
    }
    /* a stack plays like a GIF: slower beats, looping three times */
    if (stack && !partsMode) { state.speed = speedFor(stack.beat || .35); state.plays = String(stack.plays || 3); }
    /* opts.mount: build into that element as a page (the Video tab) instead of a full-screen overlay */
    var inline = !!opts.mount;
    var prevOverflow = document.documentElement.style.overflow;
    if (!inline) { document.documentElement.style.overflow = 'hidden'; }
    var templateLabel = fileLabel((opts.template || 'template') + '.jpg');

    var root = document.createElement('div');
    root.className = 'mx-sheet';
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Make a video'); root.tabIndex = -1;
    root.innerHTML =
      '<section class="mx-sheet__stage" data-stage>' +
        '<div class="mx-sheet__view" data-view>' +
          '<div class="mx-sheet__frame" data-frame>' +
            '<canvas class="mx-sheet__canvas" aria-label="The template. Drop or tap to add your photo."></canvas>' +
            /* No filename caption and no watermark line under the frame (25 Sep, Kaitlin: "remove thiss and pay to
               remove watermark emssage"). The elements stay so nothing else has to change; they are just empty. */
            '<span class="mx-sheet__fname" data-fname hidden></span>' +
            /* says why the mark is there, right under the frame it's on */
            '<span class="mx-sheet__mark" data-marknote hidden></span>' +
            '<span class="mx-sheet__hop" data-hop hidden>' + CURSOR + '</span>' +
            '<div class="mx-sheet__pop" data-pop hidden><span data-pop-a></span><span data-pop-b></span>' +
              '<i class="mx-sheet__popbar" data-pop-bar hidden><b></b></i></div>' +
            /* the loader (21 Sep, Kaitlin: "a really cute aesthetic loading bar, high dopamine"): one for every wait */
            '<div class="mx-load" data-load hidden role="status" aria-live="polite">' +
              '<p class="mx-load__label"><em data-load-label></em></p>' +
              '<div class="mx-load__track"><i class="mx-load__fill" data-load-fill><b class="mx-load__heart"><svg viewBox=\'0 0 24 24\' aria-hidden=\'true\'><path d=\'M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.5.7-1.3 2.2-2.5 4.3-2.5 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z\'/></svg></b></i></div>' +
              '<p class="mx-load__meta"><span data-load-sub></span><span class="mx-load__pct" data-load-pct>0%</span></p>' +
              '<div class="mx-load__acts" data-load-acts hidden></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="mx-sheet__bar" data-bar hidden>' +
          '<button type="button" class="mx-sheet__play" data-play aria-label="Play"></button>' +
          '<input type="range" class="mx-sheet__scrub" data-scrub min="0" max="1" value="0" aria-label="Move through the video">' +
          '<span class="mx-sheet__time" data-time>0.0s</span>' +
          '<button type="button" class="mx-sheet__switch" role="switch" aria-checked="true" aria-label="Blank or finished" data-switch><span>Off</span><span>On</span></button>' +
        '</div>' +
        '<input type="file" accept="image/png,image/jpeg,image/webp"' + (stack ? ' multiple' : '') + ' data-file hidden>' +
      '</section>' +
      '<aside class="mx-sheet__panel">' +
        '<div class="mx-sheet__head"><p class="mx-sheet__title">Make a <em>video.</em></p>' + (inline ? '' : '<button type="button" class="mx-sheet__close" data-close>Close</button>') + '</div>' +
        '<div class="mx-sheet__steps" data-steps>' +
          '<div class="mx-sheet__step"><span class="mx-sheet__num">1</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Your photo</span></div>' +
            (stack ?
            '<div class="mx-sheet__tray" data-tray></div>' +
            '<p class="mx-sheet__hint" data-tray-hint></p>' +
            '<button type="button" class="mx-sheet__btn mx-sheet__up" data-build hidden>Make the video</button>'
            :
            '<div data-photo-none>' +
              '<button type="button" class="mx-sheet__btn mx-sheet__up" data-upload>Upload your photo</button>' +
              '<p class="mx-sheet__hint mx-sheet__up-note">Or drop it on the template.</p>' +
            '</div>' +
            '<div data-photo-some hidden>' +
              '<div class="mx-sheet__photo"><img alt="" data-thumb><span data-photo-name></span></div>' +
              '<div class="mx-sheet__pills"><button type="button" class="mx-sheet__pill" data-change>Change photo</button></div>' +
            '</div>') +
            '<i class="mx-sheet__upbar" data-up-bar hidden><b></b></i>' +
            '<p class="mx-sheet__err" data-err role="alert" hidden></p>' +
          '</div></div>' +
          '<div class="mx-sheet__step" data-step-order' + (stack && !partsMode ? ' hidden' : '') + '><span class="mx-sheet__num">2</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Order</span><span class="mx-sheet__val" data-order-val></span></div>' +
            '<div class="mx-sheet__pills" data-pills="order"></div>' +
          '</div></div>' +
          '<div class="mx-sheet__step"><span class="mx-sheet__num">3</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Beat</span><span class="mx-sheet__val" data-beat-val></span></div>' +
            '<input type="range" class="mx-sheet__range" data-speed min="0" max="100" step="1" aria-label="Speed">' +
            '<p class="mx-sheet__ends"><span>Slower</span><span>Faster</span></p>' +
            '<div class="mx-sheet__tap"><button type="button" class="mx-sheet__tapbtn" data-tempo>Tap</button><p class="mx-sheet__hint" data-tempo-hint>Tap to your song.</p></div>' +
          '</div></div>' +
          '<div class="mx-sheet__step"><span class="mx-sheet__num">4</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Sound</span></div>' +
            '<div class="mx-sheet__pills" data-pills="sound"></div>' +
            '<p class="mx-sheet__hint mx-sheet__nosound" data-nosound hidden>This browser can’t put sound in a video, so this one will be silent. Chrome can.</p>' +
          '</div></div>' +
          '<div class="mx-sheet__step"><span class="mx-sheet__num">5</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Size</span></div>' +
            '<div class="mx-sheet__pills" data-pills="size"></div>' +
          '</div></div>' +
          '<div class="mx-sheet__step"><span class="mx-sheet__num">6</span><div class="mx-sheet__step-body">' +
            '<div class="mx-sheet__step-head"><span class="mx-sheet__step-name">Ending</span></div>' +
            '<p class="mx-sheet__hint">Play it</p>' +
            '<div class="mx-sheet__pills" data-pills="plays"></div>' +
          '</div></div>' +
        '</div>' +
        '<div class="mx-sheet__foot">' +

          '<button type="button" class="mx-sheet__btn mx-sheet__make" data-make disabled>Make video</button>' +
          '<div class="mx-sheet__progress" data-progress hidden><i></i></div>' +
          '<p class="mx-sheet__status" data-status role="status"></p>' +
          '<div class="mx-sheet__result" data-result hidden>' +
            '<video playsinline controls></video>' +
            '<div class="mx-sheet__menu"><button type="button" data-save>Download video</button><button type="button" data-share hidden>Share</button></div>' +

          '</div>' +
        '</div>' +
      '</aside>';
    if (inline) { root.classList.add('mx-sheet--inline'); root.removeAttribute('role'); root.removeAttribute('aria-modal'); opts.mount.appendChild(root); }
    else { document.body.appendChild(root); }

    var q = function (s) { return root.querySelector(s); };
    var stage = q('[data-stage]'), canvas = q('canvas'), ctx = canvas.getContext('2d'), frameEl = q('[data-frame]');
    var playBtn = q('[data-play]'), scrub = q('[data-scrub]'), timeEl = q('[data-time]'), sw = q('[data-switch]');
    var mode = 'template', scale = .5, playing = false, frame = 0, t0 = 0, last = -1, dirty = true, raf = 0;
    var busy = false, blob = null, blobUrl = null, ac = null, bus = null, aStart = null, hopTimer = 0, workStart = 0, photoUrl = null;

    /* ---- sound ---- */
    function audio() {
      if (!ac) { try { ac = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { return null; } }
      if (ac.state === 'suspended') { ac.resume().catch(function () {}); }
      return ac;
    }
    function hush() { if (bus) { try { bus.disconnect(); } catch (e) {} bus = null; } }
    function sfx(i, n) {
      if (state.sound === 'none' || !audio()) { return; }
      if (!bus) { bus = ac.createGain(); bus.connect(ac.destination); }
      play(state.sound, ac, bus, ac.currentTime + .005, i, n);
    }

    /* ---- modes ---- */
    function setMode(m) {
      mode = m;
      q('[data-bar]').hidden = m !== 'ready';
      q('[data-make]').disabled = m !== 'ready' || busy;
      q('[data-hop]').hidden = m === 'ready';
      q('[data-hop]').classList.toggle('is-idle', m === 'template');
      markNote(!!opts.watermark && reveal.hasFull());
      frameEl.classList.toggle('is-empty', m === 'template');
      if (m !== 'working') { renderStep(0, 0); }
      clearInterval(hopTimer);
      if (m === 'working') { hop(); hopTimer = setInterval(hop, 520); }
      if (m === 'template') { rest(); }
      pop();
      changed();
    }
    /* no photo yet: the cursor sits on one sheet, tapping, as a hint to drop or tap */
    function rest() {
      var n = reveal.sheets(), s = find(SIZES, state.size), el = q('[data-hop]');
      if (!n && !stack) { return; }
      var p = stack ? { x: .56, y: .5 } : reveal.where(Math.ceil(n / 2) + 1, s.W, s.H);
      el.style.left = (p.x * 100) + '%'; el.style.top = (p.y * 100) + '%';
    }
    function hop() {
      var n = reveal.sheets(), s = find(SIZES, state.size), el = q('[data-hop]');
      if (!n) { return; }
      var k = 1 + Math.floor(Math.random() * n), p = reveal.where(k, s.W, s.H);
      el.style.left = (p.x * 100) + '%'; el.style.top = (p.y * 100) + '%';
      el.classList.remove('is-press'); setTimeout(function () { el.classList.add('is-press'); }, 380);
      pop();
    }
    function pop() {
      var el = q('[data-pop]'), a = q('[data-pop-a]'), b = q('[data-pop-b]');
      if (mode === 'template') {
        el.hidden = false;
        a.textContent = stack && items.length ? items.length + (items.length === 1 ? ' photo picked' : ' photos picked') : (stack && maxPhotos > 1 ? 'Drop your photos here' : 'Drop your photo here');
        b.textContent = stack && items.length ? (items.length < minPhotos ? 'add ' + (minPhotos - items.length) + ' more' : 'press Make the video') : 'or tap';
      } else if (mode === 'working') {
        el.hidden = !!q('[data-load]');
        a.textContent = stack && maxPhotos > 1 ? 'Adding your photos' : 'Adding your photo';
        b.textContent = Math.floor((performance.now() - workStart) / 1000) + 's';
      } else {
        el.hidden = true;
      }
    }
    /* ---- preview ---- */
    function sizeCanvas() {
      var s = find(SIZES, state.size);
      scale = Math.min(1, 1280 / Math.max(s.W, s.H));
      canvas.width = Math.round(s.W * scale); canvas.height = Math.round(s.H * scale);
      dirty = true;
    }
    /* Playback runs on the audio clock when there is one: every beat's sound is scheduled ahead of time and the
       picture reads the same clock, so they can't drift apart. Without audio it falls back to the page clock. */
    function clock() {
      if (ac && ac.state === 'running' && aStart != null) { return ac.currentTime - aStart; }
      return (performance.now() - t0) / 1000;
    }
    function startClock() {
      t0 = performance.now() - frame / OUT * 1000;
      hush(); aStart = null;
      if (!ac || ac.state !== 'running') { return; }
      aStart = ac.currentTime + .04 - frame / OUT;
      if (state.sound === 'none') { return; }
      var from = frame / OUT - .001;
      bus = ac.createGain(); bus.connect(ac.destination);
      reveal.beats().forEach(function (b) { if (b.at >= from) { play(state.sound, ac, bus, aStart + b.at, b.i, b.n, b.room); } });
    }
    function setPlaying(p) {
      var T = reveal.timing();
      if (p && frame >= T.total - 1) { frame = 0; }
      playing = p && mode === 'ready';
      if (playing) {
        state.view = null; sw.setAttribute('aria-checked', 'true');
        audio(); startClock();
        if (ac && ac.state !== 'running') { ac.resume().then(function () { if (playing) { startClock(); } }).catch(function () {}); }
      }
      else { hush(); aStart = null; }
      playBtn.innerHTML = playing ? PAUSE : PLAY;
      playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      pop(); dirty = true;
    }
    function forcedStep() {
      if (state.view === 'off') { return 0; }
      if (state.view === 'on') { return reveal.sheets(); }
      if (mode === 'working') { return 0; }
      return null;
    }
    function changed() {
      var T = reveal.timing();
      if (frame >= T.total) { frame = T.total - 1; }
      if (playing) { startClock(); }
      scrub.max = String(Math.max(0, T.total - 1));
      q('[data-beat-val]').textContent = T.beat.toFixed(2) + 's each';
      var s = find(SIZES, state.size);
      /* a beat is one photo, unless the page asked for more beats than photos (the spiral pad turns one page at
         a time, so a photo lasts two), and then it's plainer to count frames */
      var picked = (items || []).length;
      var unit = stack ? (maxPhotos === 1 || (picked && T.n !== picked) ? ' frames · ' : ' photos · ') : ' parts · ';
      /* No counts line above the button (25 Sep, Kaitlin: "remvoe all these little messages… its bad copy"). */
      q('[data-make]').disabled = mode !== 'ready' || busy;
      dirty = true;
    }
    function loop(now) {
      var T = reveal.timing();
      if (playing) {
        frame = Math.max(0, Math.floor(clock() * OUT + 1e-6));
        if (frame >= T.total - 1) { frame = T.total - 1; setPlaying(false); }
      }
      if (mode === 'working' && now - workStart > 0) { var b = q('[data-pop-b]'); var secs = Math.floor((now - workStart) / 1000) + 's'; if (b.textContent !== secs) { b.textContent = secs; } }
      if (frame !== last || dirty) {
        var s = find(SIZES, state.size);
        ctx.setTransform(scale, 0, 0, scale, 0, 0);
        reveal.draw(ctx, s.W, s.H, frame, forcedStep());
        scrub.value = String(frame);
        timeEl.textContent = (frame / OUT).toFixed(1) + 's';
        last = frame; dirty = false;
      }
      raf = requestAnimationFrame(loop);
    }

    /* ---- photo in ---- */
    var fileIn = q('[data-file]');
    function showError(t, link) {
      var e = q('[data-err]'); e.textContent = t || ''; e.hidden = !t;
      if (t && link) { var a = document.createElement('a'); a.href = link.href; a.textContent = link.label; a.className = 'mx-sheet__errlink'; e.appendChild(document.createTextNode(' ')); e.appendChild(a); }
    }
    /* opts.beforeUpload() returning false stops the file picker (e.g. sends a logged-out visitor to log in) */
    function pick() { if (opts.beforeUpload && opts.beforeUpload() === false) { return; } audio(); fileIn.click(); }
    function takeFile(f) {
      if (!f || busy) { return; }
      if (!/^image\/(png|jpeg|webp)$/.test(f.type)) { showError('That isn’t a PNG, JPG or WebP. Try another file.'); return; }
      if (f.size > 8 * 1024 * 1024) { showError('That file is over 8MB. Try a smaller one.'); return; }
      if (!opts.render) { showError('Uploads aren’t switched on here.'); return; }
      audio(); showError('');
      if (photoUrl) { URL.revokeObjectURL(photoUrl); }
      photoUrl = URL.createObjectURL(f);
      setPlaying(false); state.view = null;
      workStart = performance.now();
      setMode('working'); loadStart(MAKING); renderStep(0, 0);
      Promise.resolve(opts.render(f, renderStep))
        .then(loadImg)
        .then(function (img) { ready(img, photoUrl, fileLabel(f.name)); loadDone('Ready'); })
        .catch(function (e) { loadHide(); setMode(reveal.hasFull() ? 'ready' : 'template'); showError((e && e.message) || 'That didn’t work. Try again.', e && e.link); });
    }
    /* stack mode: a tray of photos (2 to maxPhotos). Pick, reorder, remove; nothing renders until Make the video.
       After that, changes show 'Update the video'. The render function decides what actually needs rendering. */
    var items = [], rendered = false, changedPhotos = false, uid = 0, dragFrom = -1;
    /* opts.buildNote: what Make the video costs, shown on it until handle.setPaid() */
    var buildNote = opts.buildNote || '';
    function takeFiles(list) {
      if (busy) { return; }
      var files = Array.prototype.slice.call(list || []).filter(function (f) { return /^image\/(png|jpeg|webp)$/.test(f.type); });
      if (!files.length) { showError('Those aren’t PNG, JPG or WebP files. Try others.'); return; }
      if (files.some(function (f) { return f.size > 8 * 1024 * 1024; })) { showError('One of those is over 8MB. Try a smaller one.'); return; }
      /* one-photo videos (the envelope): a new photo replaces the old one */
      if (maxPhotos === 1 && items.length) { items.forEach(function (it) { URL.revokeObjectURL(it.url); }); items = []; }
      var room = maxPhotos - items.length;
      if (room <= 0) { showError('That’s ' + maxPhotos + ' photos, the most one video takes. Remove one first.'); return; }
      files.slice(0, room).forEach(function (f) { items.push({ id: ++uid, file: f, url: URL.createObjectURL(f) }); });
      showError(files.length > room ? 'Only ' + maxPhotos + ' photos fit, so the first ' + room + ' were added.' : '');
      audio(); changedPhotos = true; drawTray(); pop();
    }
    function drawTray() {
      var wrap = q('[data-tray]'); wrap.innerHTML = '';
      items.forEach(function (it, i) {
        var t = document.createElement('div');
        t.className = 'mx-sheet__tile'; t.draggable = true;
        t.innerHTML = '<img alt="Photo ' + (i + 1) + '" src="' + it.url + '"><b>' + (i + 1) + '</b><button type="button" class="mx-sheet__x" aria-label="Remove photo ' + (i + 1) + '">×</button>';
        t.querySelector('.mx-sheet__x').addEventListener('click', function () {
          if (busy) { return; }
          URL.revokeObjectURL(it.url); items.splice(i, 1); changedPhotos = true; drawTray(); pop();
        });
        t.addEventListener('dragstart', function (e) { dragFrom = i; t.classList.add('is-dragging'); e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(i)); });
        t.addEventListener('dragend', function () { t.classList.remove('is-dragging'); dragFrom = -1; });
        t.addEventListener('dragover', function (e) { if (dragFrom > -1) { e.preventDefault(); t.classList.add('is-over'); } });
        t.addEventListener('dragleave', function () { t.classList.remove('is-over'); });
        t.addEventListener('drop', function (e) {
          if (dragFrom < 0) { return; }
          e.preventDefault(); e.stopPropagation();
          if (dragFrom !== i && !busy) { var moved = items.splice(dragFrom, 1)[0]; items.splice(i, 0, moved); changedPhotos = true; }
          dragFrom = -1; drawTray(); pop();
        });
        wrap.appendChild(t);
      });
      if (items.length < maxPhotos) {
        var add = document.createElement('button');
        add.type = 'button'; add.className = 'mx-sheet__add' + (items.length ? '' : ' is-empty');
        add.innerHTML = items.length ? '<span>+</span>' : '<span>+</span> Add photos';
        add.setAttribute('aria-label', 'Add photos');
        add.addEventListener('click', pick);
        wrap.appendChild(add);
      }
      var n = items.length, hint = q('[data-tray-hint]'), build = q('[data-build]');
      hint.innerHTML = maxPhotos === 1
        /* short (21 Sep, Kaitlin: "way too much copy here"); the price is on the Download button */
        ? (!n ? 'One photo.' : 'Drop another to swap it.')
        : !n
        ? minPhotos + ' to ' + maxPhotos + ' photos.'
        : n < minPhotos
          ? 'Add at least ' + minPhotos + '.'
          : 'Drag to reorder.';
      build.hidden = n < minPhotos || (rendered && !changedPhotos);
      build.disabled = busy || n < minPhotos;
      build.textContent = rendered ? 'Update the video' : 'Make the video' + buildNote;
    }
    function build() {
      if (busy || items.length < minPhotos || !opts.render) { return; }
      audio(); showError('');
      setPlaying(false); state.view = null;
      workStart = performance.now();
      var back = mode;
      setMode('working'); drawTray(); loadStart(MAKING); renderStep(0, 0);
      Promise.resolve(opts.render(items.map(function (it) { return it.file; }), renderStep))
        .then(function (urls) { return Promise.all(urls.map(function (u) { return loadImg(u); })); })
        .then(function (imgs) {
          reveal.set({ frames: imgs });
          rendered = true; changedPhotos = false;
          q('[data-result]').hidden = true; q('[data-status]').textContent = pendingMessage || ''; pendingMessage = null;
          frame = 0; setMode('ready'); drawTray(); setPlaying(true); loadDone('Ready');
        })
        .catch(function (e) { loadHide(); setMode(back === 'working' ? (rendered ? 'ready' : 'template') : back); drawTray(); showError((e && e.message) || 'That didn’t work. Try again.', e && e.link); });
    }
    function ready(img, thumb, label) {
      reveal.set({ full: img });
      q('[data-thumb]').src = thumb; q('[data-photo-name]').textContent = label;
      q('[data-photo-none]').hidden = true; q('[data-photo-some]').hidden = false; showError('');
      q('[data-result]').hidden = true; q('[data-status]').textContent = '';
      state.taps = [];
      frame = 0; setMode('ready');
      setPlaying(true);
    }
    if (stack) { q('[data-build]').addEventListener('click', build); drawTray(); }
    else { q('[data-upload]').addEventListener('click', pick); q('[data-change]').addEventListener('click', pick); }
    fileIn.addEventListener('change', function () {
      var list = Array.prototype.slice.call(fileIn.files); fileIn.value = '';
      if (stack) { takeFiles(list); } else { takeFile(list[0]); }
    });
    var depth = 0;
    function isFiles(e) { return e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') > -1; }
    stage.addEventListener('dragenter', function (e) { if (isFiles(e)) { depth++; stage.classList.add('is-over'); } });
    stage.addEventListener('dragleave', function (e) { if (isFiles(e) && --depth <= 0) { depth = 0; stage.classList.remove('is-over'); } });
    stage.addEventListener('dragover', function (e) { if (isFiles(e)) { e.preventDefault(); } });
    stage.addEventListener('drop', function (e) {
      if (!isFiles(e)) { return; }
      e.preventDefault(); depth = 0; stage.classList.remove('is-over');
      if (opts.beforeUpload && opts.beforeUpload() === false) { return; }
      audio();
      if (stack) { takeFiles(e.dataTransfer.files); } else { takeFile(e.dataTransfer.files[0]); }
    });

    /* the empty template is a second way in to the file picker; nothing else on the canvas is clickable
       (Kaitlin, 20 Sep: "how come i can click these squares? bit wierd" — Tap your own is gone) */
    canvas.addEventListener('click', function () { if (mode === 'template') { pick(); } });

    /* ---- controls ---- */
    var pillSets = {};
    function selectPill(key, id) {
      state[key] = id;
      Array.prototype.forEach.call(pillSets[key].children, function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-id') === id)); });
    }
    function pills(key, list, after) {
      var wrap = q('[data-pills="' + key + '"]'); pillSets[key] = wrap;
      list.forEach(function (o) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mx-sheet__pill'; b.textContent = o.label;
        b.setAttribute('data-id', o.id); b.setAttribute('aria-pressed', String(state[key] === o.id));
        b.addEventListener('click', function () { var again = state[key] === o.id; selectPill(key, o.id); if (after) { after(o.id, again, b); } changed(); });
        wrap.appendChild(b);
      });
    }
    /* If the browser can't encode sound, say so before they make anything and turn the sound off, instead of handing
       them a silent video afterwards (23 Sep). */
    if (window.MeMotion && window.MeMotion.canSound) {
      window.MeMotion.canSound().then(function (ok) {
        if (ok) { return; }
        state.sound = 'none';
        var note = q('[data-nosound]'); if (note) { note.hidden = false; }
        var wrap = pillSets.sound;
        if (wrap) {
          Array.prototype.forEach.call(wrap.children, function (b) {
            var none = b.getAttribute('data-id') === 'none';
            b.setAttribute('aria-pressed', String(none));
            if (!none) { b.disabled = true; b.title = 'Sound needs Chrome'; }
          });
        }
      });
    }
    pills('order', ORDERS, function (id, again, b) {
      if (id === 'shuffle') { if (again) { state.seed++; } b.textContent = 'Shuffle again'; } else { pillSets.order.children[1].textContent = 'Shuffle'; }
      frame = 0; setPlaying(true); pop();
    });
    pills('sound', SOUNDS, function (id) { hush(); if (id !== 'none') { sfx(3, 16); } });
    pills('size', SIZES, function () { sizeCanvas(); });
    pills('plays', PLAYS, function () { frame = 0; });

    var speed = q('[data-speed]');
    speed.value = String(state.speed);
    speed.addEventListener('input', function () {
      var step = reveal.stepAt(frame, reveal.timing());
      state.speed = +speed.value;
      var T = reveal.timing();
      if (T.n && step) { frame = Math.round((T.intro + (step - 1) * T.beat) * OUT); }
      q('[data-tempo-hint]').textContent = 'Tap to your song.';
      hush(); changed();
    });

    /* tap tempo: the gap between taps becomes the time per sheet */
    var tempo = [], tempoBtn = q('[data-tempo]');
    tempoBtn.addEventListener('click', function () {
      var now = performance.now();
      if (tempo.length && now - tempo[tempo.length - 1] > 2000) { tempo = []; }
      tempo.push(now);
      tempoBtn.classList.remove('is-hit'); void tempoBtn.offsetWidth; tempoBtn.classList.add('is-hit');
      setTimeout(function () { tempoBtn.classList.remove('is-hit'); }, 110);
      sfx(Math.min(tempo.length, 15) - 1, 16);
      var hint = q('[data-tempo-hint]');
      if (tempo.length < 4) { hint.textContent = 'Keep going. ' + (4 - tempo.length) + ' more.'; return; }
      var gaps = []; for (var i = 1; i < tempo.length; i++) { gaps.push(tempo[i] - tempo[i - 1]); }
      gaps = gaps.slice(-6).sort(function (a, b) { return a - b; });
      var beat = Math.max(FASTEST, Math.min(SLOWEST, gaps[Math.floor(gaps.length / 2)] / 1000));
      state.speed = speedFor(beat); speed.value = String(state.speed);
      hint.textContent = 'Set from your taps. Keep tapping to adjust.';
      changed();
    });

    playBtn.addEventListener('click', function () { audio(); setPlaying(!playing); });
    scrub.addEventListener('input', function () { setPlaying(false); state.view = null; sw.setAttribute('aria-checked', 'true'); frame = +scrub.value; dirty = true; pop(); });
    sw.addEventListener('click', function () {
      if (mode !== 'ready') { return; }
      setPlaying(false);
      state.view = sw.getAttribute('aria-checked') === 'true' ? 'off' : 'on';
      sw.setAttribute('aria-checked', String(state.view === 'on'));
      pop(); dirty = true;
    });

    /* ---- export ---- */
    /* opts.beforeExport (the Video page): runs before the MP4 is made, e.g. unlock a paid video and fetch full-size
       renders. Resolves { frames: [urls] } (stack) or { full: url } (parts) to swap in, or null to go ahead as is.
       Its errors can carry e.link, shown after the message. opts.exportLabel / handle.setExportLabel set the button. */
    var exportLabel = opts.exportLabel || 'Make video', madeOnce = false;
    function status(t, link) {
      var el = q('[data-status]'); el.textContent = t || '';
      if (t && link) { var a = document.createElement('a'); a.href = link.href; a.textContent = link.label; a.className = 'mx-sheet__errlink'; el.appendChild(document.createTextNode(' ')); el.appendChild(a); }
    }
    function progress(p) {
      q('[data-progress] i').style.width = (p * 100).toFixed(1) + '%';
      if (ld.on) { loadTo(.35 + .65 * p, .35 + .65 * Math.min(1, p + .06)); }
    }
    /* opts.render calls this as each photo uploads and each frame lands, so both waits are a bar and not just a
       clock. Uploading fills the bar under step 1, rendering fills the one in the pop over the template. A
       one-frame template has nothing to count, so it keeps the seconds. */
    /* ---- the loader ----
       shown eases toward target (real progress). While waiting on a step it creeps slowly toward cap, just short of
       where the next step would land, so a single slow render still moves; it never passes a step that hasn't
       happened. loadDone runs it to 100, pops, lets a few hearts float up, then fades out. */
    var ld = { on: false, done: false, target: 0, cap: 0, shown: 0, raf: 0, hold: false };
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function loadStart(label, sub) {
      var el = q('[data-load]'); if (!el) { return; }
      ld.on = true; ld.done = false; ld.hold = false; ld.target = 0; ld.cap = .08; ld.shown = 0;
      el.classList.remove('is-done', 'is-out'); el.hidden = false;
      loadText(label, sub);
      loadSchedule();
    }
    /* animation frames stop while the tab is hidden (say they're paying in the checkout tab), so it falls back to
       a timer there and still finishes */
    function loadSchedule() {
      if (ld.raf) { return; }
      ld.raf = document.hidden ? setTimeout(loadTick, 120) : requestAnimationFrame(loadTick);
    }
    function loadText(label, sub) {
      if (sub == null) { sub = ''; }
      if (label != null) { q('[data-load-label]').textContent = label; }
      if (sub != null) { q('[data-load-sub]').textContent = sub; }
    }
    function loadTo(p, cap) {
      if (!ld.on) { return; }
      ld.target = Math.max(ld.target, Math.min(1, p));
      ld.cap = Math.max(ld.cap, Math.min(.97, cap != null ? cap : p));
    }
    function loadTick() {
      ld.raf = 0;
      if (!ld.on) { return; }
      var goal = ld.done ? 1 : ld.target;
      /* the finish snaps: a quick fill to 100 feels like the reward, a slow crawl doesn't */
      if (ld.shown < goal) { ld.shown += ld.done ? Math.max(.025, (goal - ld.shown) * .3) : Math.max(.004, (goal - ld.shown) * .16); }
      else if (!ld.done && !ld.hold && ld.shown < ld.cap) { ld.shown += (ld.cap - ld.shown) * .012; }
      ld.shown = Math.min(ld.done ? 1 : .99, ld.shown);
      var fill = q('[data-load-fill]'), pct = q('[data-load-pct]');
      fill.style.width = (ld.shown * 100).toFixed(2) + '%';
      pct.textContent = Math.round(ld.shown * 100) + '%';
      if (ld.done && ld.shown >= .999) { loadCheer(); return; }
      loadSchedule();
    }
    /* small buttons on the loader, e.g. Back to checkout / Cancel while waiting on a payment */
    function loadActs(list) {
      var box = q('[data-load-acts]'); if (!box) { return; }
      box.innerHTML = ''; box.hidden = !(list && list.length);
      (list || []).forEach(function (a) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mx-load__act' + (a.main ? ' is-main' : ''); b.textContent = a.label;
        b.addEventListener('click', function (e) { e.stopPropagation(); a.fn(); });
        box.appendChild(b);
      });
    }
    function loadDone(label) {
      if (!ld.on) { return; }
      loadActs(null);
      ld.done = true; if (label) { loadText(label, ''); }
      if (document.hidden) { ld.shown = 1; }
      loadSchedule();
    }
    function loadCheer() {
      var el = q('[data-load]');
      el.classList.add('is-done');
      if (!calm) {
        for (var i = 0; i < 7; i++) {
          var h = document.createElement('i'); h.className = 'mx-load__pop';
          h.innerHTML = '<svg viewBox=\'0 0 24 24\' aria-hidden=\'true\'><path d=\'M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.5.7-1.3 2.2-2.5 4.3-2.5 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z\'/></svg>';
          h.style.setProperty('--x', (Math.round((i - 3) * 16 + (R(i, 11) - .5) * 14)) + 'px');
          h.style.setProperty('--d', (i * 45) + 'ms'); h.style.setProperty('--s', (.55 + R(i, 13) * .6).toFixed(2));
          el.appendChild(h);
        }
      }
      setTimeout(function () { el.classList.add('is-out'); }, calm ? 300 : 850);
      setTimeout(function () { loadHide(); }, calm ? 600 : 1250);
    }
    function loadHide() {
      var el = q('[data-load]'); if (!el) { return; }
      ld.on = false; ld.done = false; if (ld.raf) { cancelAnimationFrame(ld.raf); clearTimeout(ld.raf); ld.raf = 0; }
      el.hidden = true; el.classList.remove('is-done', 'is-out'); loadActs(null);
      Array.prototype.forEach.call(el.querySelectorAll('.mx-load__pop'), function (h) { h.remove(); });
    }
    /* previews: uploading is the first 30%, the renders the rest */
    function loadPreview(done, total, phase) {
      if (!ld.on || !total) { return; }
      /* the bar carries the progress; the label stays put (Kaitlin, 23 Sep: "just have loading bar … not al that
         weird copy"). Uploads are the first third of it, the renders the rest. */
      if (phase === 'upload') { loadTo(.3 * done / total, .3 * Math.min(1, (done + .6) / total)); }
      else { loadTo(.3 + .7 * done / total, .3 + .7 * Math.min(1, (done + .9) / total)); }
    }
    function renderStep(done, total, phase) {
      loadPreview(done, total, phase);
      var up = phase === 'upload', el = q(up ? '[data-up-bar]' : '[data-pop-bar]'), u = q('[data-up-bar]');
      /* let the upload bar be seen full for a moment before it goes (21 Sep) */
      if (u) { clearTimeout(u._off); if (!up && !u.hidden) { u._off = setTimeout(function () { u.hidden = true; }, 500); } }
      if (!el) { return; }
      el.hidden = !(total > (up ? 0 : 1));
      el.firstChild.style.width = total ? Math.round(done / total * 100) + '%' : '0%';
    }
    function makeLabel() { return madeOnce ? (opts.againLabel || 'Make video again') : exportLabel; }
    q('[data-make]').addEventListener('click', function () {
      if (busy || mode !== 'ready' || !window.MeMotion) { return; }
      /* Inside the tap: an iPhone only lets an AudioContext start from a gesture, and the recorder needs a
         running one to put sound in the video (25 Sep). */
      audio();
      busy = true; changed();
      var make = q('[data-make]'), encoding = false;
      setPlaying(false);
      make.textContent = EXPORTING + '…';
      q('[data-result]').hidden = true; status('');
      loadStart(EXPORTING);
      if (opts.beforeExport) { loadTo(.02, .33); }
      Promise.resolve(opts.beforeExport ? opts.beforeExport() : null)
        .then(function (up) {
          if (up && up.frames) { return Promise.all(up.frames.map(function (u) { return loadImg(u); })).then(function (imgs) { reveal.set({ frames: imgs }); }); }
          if (up && up.full) { return loadImg(up.full).then(function (img) { reveal.set({ full: img }); }); }
        })
        .then(function () {
          encoding = true; dirty = true;
          make.textContent = EXPORTING + '…';
          q('[data-progress]').hidden = false; progress(0);
          ld.hold = false; loadText(EXPORTING); loadTo(.35, .4);
          var s = find(SIZES, state.size);
          var painter = { timing: reveal.timing, draw: function (c, W, H, f) { reveal.draw(c, W, H, f); }, ac: ac };
          if (state.sound !== 'none') { painter.audio = function (oac) { reveal.sounds(oac, oac.destination); }; }
          return window.MeMotion.encode(painter, s.W, s.H, progress).then(function (b) { return { b: b, painter: painter }; });
        })
        .then(function (out) {
          var b = out.b; blob = b; madeOnce = true;
          if (opts.onMade) { try { opts.onMade(b, fileName()); } catch (e) {} }
          if (blobUrl) { URL.revokeObjectURL(blobUrl); }
          blobUrl = URL.createObjectURL(b);
          q('[data-result] video').src = blobUrl;
          q('[data-result]').hidden = false;
          var file = new File([b], fileName(), { type: b.type });
          var canShare = !!(navigator.canShare && navigator.canShare({ files: [file] }));
          /* Phones: the camera roll is where they want it (21 Sep, Kaitlin: "when they download vid it goes to their
             camera roll"). A web page can't write to Photos by itself; the share sheet's Save Video can, so on a
             phone that button comes first and says what it does. Only MP4 goes into Photos. Elsewhere it's Share. */
          var phone = !!(window.matchMedia && matchMedia('(pointer: coarse)').matches);
          var roll = canShare && /mp4/.test(b.type) && phone;
          var shareBtn = q('[data-share]'), saveBtn = q('[data-save]');
          /* ONE button under the video, never two (6 Oct, Kaitlin: "dont need share buttons and dont need 2
             download buttons?"). A phone gets Save to camera roll, the only thing that reaches Photos, and
             nothing else. A computer has already saved the file by itself below, so its button is just a second
             chance and says so. Share is gone: it was offered on a computer purely because the browser could,
             and nobody asked to share from here. */
          shareBtn.hidden = !roll;
          shareBtn.textContent = 'Save to camera roll';
          shareBtn.classList.toggle('is-main', roll);
          if (roll && shareBtn.parentNode.firstChild !== shareBtn) { shareBtn.parentNode.insertBefore(shareBtn, shareBtn.parentNode.firstChild); }
          /* They pressed Download, so on a computer the file saves itself (21 Sep: it used to stop at "Download it
             again" with nothing saved). Phones keep the camera roll button, which needs its own tap. */
          var saved = false;
          if (!roll && !phone) { try { saveBtn.click(); saved = true; } catch (e) { saved = false; } }
          saveBtn.hidden = roll;
          saveBtn.textContent = saved ? 'Download again' : 'Download video';
          /* It worked: the video is right there, so nothing needs saying (25 Sep). The line is kept for failures. */
          status(out.painter.silent ? 'This one is silent: the browser would not add sound.' : '');
          keepIt(b);
          loadDone('Ready');
          q('[data-result]').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        })
        .catch(function (e) {
          loadHide();
          if (!encoding) { status((e && e.message) || 'That didn’t work. Try again.', e && e.link); return; }
          status((e && e.name === 'SecurityError' ? 'The browser wouldn’t let these renders be saved into a video.' : (e && e.message) || 'Something stopped the video being made.') + ' Try again, or try Chrome.');
        })
        .then(function () {
          busy = false; make.textContent = makeLabel();
          q('[data-progress]').hidden = true; changed();
        });
    });
    function fileName() { return 'mock-exchange-video.' + (blob && blob.type.indexOf('mp4') === -1 ? 'webm' : 'mp4'); }
    /* Keep the finished video somewhere it can be got at again (23 Sep, Kaitlin: "when i click download / export …
       it doesnt go anywhere or save anywhere? can it go somewhere like a server"). opts.keep uploads it and hands
       back a link. In a browser that can share, that link is a bonus. In one that can't - Instagram's and Facebook's
       in-app browsers, where a download silently does nothing - it is the only way out, so it leads. */
    var IN_APP = /Instagram|FBAN|FBAV|FB_IAB|Line\/|Twitter|Pinterest|Snapchat|TikTok/i.test(navigator.userAgent || '');
    /* The finished video is put on their account quietly (worker /vfile), so it is waiting under Your videos
       (25 Sep, Kaitlin: "remove this sciton altogetehr… always just save to camera roll thats it"). No link, no
       copy button, nothing under the buttons. */
    function keepIt(b) {
      if (!opts.keep) { return; }
      Promise.resolve(opts.keep(b, fileName())).catch(function () { /* it is only a copy */ });
    }
    q('[data-save]').addEventListener('click', function () {
      if (!blob) { return; }
      var a = document.createElement('a'); a.href = blobUrl; a.download = fileName();
      document.body.appendChild(a); a.click(); a.remove();
    });
    /* The GIF is gone (28 Sep, Kaitlin: "i think remove option for GIF on export"). It never worked on her
       machine and the MP4 is what gets posted. gifenc and makeGif() went with it; git has them if it comes back. */
    /* The button reports back instead of looking like nothing happened (30 Sep, Kaitlin: "if i click save to
       camera roll it needs to say saved in that same button when done"). It goes back to itself after a moment,
       so they can save it again. */
    q('[data-share]').addEventListener('click', function () {
      if (!blob) { return; }
      var b = this, was = b.textContent;
      navigator.share({ files: [new File([blob], fileName(), { type: blob.type })] }).then(function () {
        b.textContent = 'Saved';
        setTimeout(function () { if (b.textContent === 'Saved') { b.textContent = was; } }, 4000);
      }).catch(function () { /* they backed out of the share sheet */ });
    });

    /* ---- open / close ---- */
    function onKey(e) {
      if (e.key === 'Escape' && !busy && !inline) { close(); }
      if (e.code === 'Space' && mode === 'ready' && !/INPUT|BUTTON|VIDEO/.test(e.target.tagName)) { e.preventDefault(); audio(); setPlaying(!playing); }
    }
    function close() {
      cancelAnimationFrame(raf); clearInterval(hopTimer); hush();
      if (ac) { ac.close().catch(function () {}); }
      document.removeEventListener('keydown', onKey);
      if (blobUrl) { URL.revokeObjectURL(blobUrl); }
      if (photoUrl) { URL.revokeObjectURL(photoUrl); }
      root.remove();
      if (!inline) { document.documentElement.style.overflow = prevOverflow; }
      current = null;
      if (opts.onClose) { opts.onClose(); }
    }
    if (!inline) { q('[data-close]').addEventListener('click', close); }
    document.addEventListener('keydown', onKey);

    playBtn.innerHTML = PLAY;
    sizeCanvas(); setMode('template');
    raf = requestAnimationFrame(loop);
    /* Size comes first, straight under the photos (21 Sep, Kaitlin: "add size under photos as first thing") */
    (function () {
      var sizeStep = root.querySelector('[data-pills="size"]'), steps = root.querySelectorAll('.mx-sheet__step');
      sizeStep = sizeStep && sizeStep.closest('.mx-sheet__step');
      if (sizeStep && steps[0] && steps[0] !== sizeStep) { steps[0].parentNode.insertBefore(sizeStep, steps[0].nextSibling); }
      Array.prototype.filter.call(root.querySelectorAll('.mx-sheet__step'), function (el) { return !el.hidden; })
        .forEach(function (el, i) { var num = el.querySelector('.mx-sheet__num'); if (num) { num.textContent = i + 1; } });
    })();
    /* stack mode has no parts map; the numbered steps close up around the hidden Order step */
    if (stack) {
      Array.prototype.filter.call(root.querySelectorAll('.mx-sheet__step'), function (el) { return !el.hidden; })
        .forEach(function (el, i) { el.querySelector('.mx-sheet__num').textContent = i + 1; });
    }
    /* the map goes with parts mode, the tray with opts.stack. A wall with several photos has both. */
    Promise.all([loadImg(opts.blank), partsMode ? mapFrom(opts.map) : null])
      .then(function (imgs) {
        var m = partsMode ? imgs[1] : null;
        if (partsMode && !m.n) { throw new Error('This template can’t be made into a video yet.'); }
        reveal.set(partsMode ? { blank: imgs[0], map: m } : { blank: imgs[0] });

        setMode(mode);
        /* opts.photos: start straight away with what the page already has (the studio's image) */
        if (stack) { if (opts.photos && opts.photos.length) { takeFiles(opts.photos); if (opts.autoBuild) { build(); } } }
        else if (opts.photos && opts.photos[0]) { takeFile(opts.photos[0]); }
      })
      .catch(function (e) { showError(e.message); });
    if (!inline) { root.focus({ preventScroll: true }); }

    q('[data-make]').textContent = makeLabel();
    var pendingMessage = opts.message || null;
    if (pendingMessage) { status(pendingMessage); }
    current = {
      close: close,
      setExportLabel: function (t) { exportLabel = t; if (!busy) { q('[data-make]').textContent = makeLabel(); } },
      setPaid: function () { reveal.setMarked(false); markNote(false); dirty = true; buildNote = ''; if (stack) { drawTray(); } },
      /* while opts.beforeExport is still going (the Video tab waiting on a checkout in another tab) */
      setStatus: function (t, link) { status(t, link); },
      /* beforeExport fetches the full-size renders, which is a minute or more on a long video. Without this the
         bar crept up to its 33% cap and stopped dead, so it read as hung (30 Sep, Kaitlin: "its been at 33% for
         2 mins now - why is there a lag?"). Now each finished frame moves it. */
      setProgress: function (done, total) {
        if (!busy) { return; }
        var n = Math.max(1, Number(total) || 1), p = Math.max(0, Math.min(1, (Number(done) || 0) / n));
        loadTo(.02 + .31 * p, .33);
      },
      setBusyLabel: function (t) {
        /* also while a video is being MADE (2 Nov: making it is where it gets paid for now), not only exported */
        if (!busy && !ld.on) { return; }
        if (busy) { q('[data-make]').textContent = t; }
        /* checkout open in another window: the loader waits honestly instead of creeping, and says what's being bought */
        if (/payment/i.test(t)) { ld.hold = true; loadText('Waiting for your payment'); }
        else if (ld.hold) { ld.hold = false; loadActs(null); loadText(busy ? EXPORTING : MAKING); }
      },
      /* list of { label, fn, main } shown on the loader while it waits, or null to clear */
      setWaiting: function (list) { loadActs(list); }
    };
    return current;
  }

  window.MeReveal = { open: open };
})();
